"use client";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function IC_Fuerza({ width, height }) {
  const { theme } = useTheme();
  const [color, setColor] = useState("#324ba6");

  useEffect(() => {
    setColor(theme === "dark" ? "#324BA6" : "#324ba6");
  }, [theme]);
  return (
    <svg
      id="_ÎÓÈ_4"
      data-name="—ÎÓÈ_4"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45 45"
      width={width}
      height={height}
    >
      <defs>
        <style>
          {`   .cls-1 {
        fill: ${color};
        stroke-width: 0px;
      }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m20.21,38.28c-.13,0-.25-.02-.38-.06-.56-.17-.94-.67-.94-1.26v-9.79c0-.13-.11-.24-.24-.24h-5c-.48,0-.92-.26-1.15-.68s-.21-.93.04-1.34L23.71,7.33c.32-.5.91-.72,1.47-.56.57.16.95.67.95,1.26v10.4c0,.13.11.24.24.24h4.98c.48,0,.93.26,1.15.69.23.42.21.94-.06,1.34l-11.14,16.98c-.25.38-.66.59-1.09.59Zm4.6-30.49c-.06,0-.13.02-.19.11l-11.17,17.59c-.07.1-.03.2,0,.24.03.05.09.12.21.12h5c.72,0,1.31.59,1.31,1.31v9.79c0,.15.11.21.17.23.06.02.18.03.27-.1l11.14-16.98c.07-.1.04-.2.01-.24-.03-.05-.09-.13-.21-.13h-4.98c-.72,0-1.31-.59-1.31-1.31v-10.4c0-.16-.11-.21-.17-.23-.02,0-.05-.01-.08-.01Z"
      />
      <g>
        <path
          className="cls-1"
          d="m32.74,38.79c-.18,0-.35-.09-.45-.24-.16-.25-.09-.58.16-.74,5.2-3.39,8.31-9.11,8.31-15.31s-3.11-11.92-8.31-15.31c-.25-.16-.32-.49-.16-.74.16-.25.49-.32.74-.16,5.51,3.59,8.79,9.64,8.79,16.21s-3.29,12.62-8.79,16.21c-.09.06-.19.09-.29.09Z"
        />
        <path
          className="cls-1"
          d="m12.26,38.79c-.1,0-.2-.03-.29-.09-5.51-3.59-8.79-9.64-8.79-16.21S6.46,9.88,11.97,6.29c.25-.16.58-.09.74.16.16.25.09.58-.16.74-5.2,3.39-8.31,9.11-8.31,15.31s3.11,11.92,8.31,15.31c.25.16.32.49.16.74-.1.16-.27.24-.45.24Z"
        />
      </g>
      <g>
        <path
          className="cls-1"
          d="m31.09,34.2c-.16,0-.32-.07-.43-.21-.18-.23-.14-.57.1-.75,3.36-2.59,5.29-6.5,5.29-10.74s-1.93-8.15-5.29-10.74c-.23-.18-.28-.52-.1-.75.18-.24.52-.28.75-.1,3.63,2.79,5.71,7.02,5.71,11.59s-2.08,8.79-5.71,11.59c-.1.08-.21.11-.33.11Z"
        />
        <path
          className="cls-1"
          d="m13.91,34.2c-.11,0-.23-.04-.33-.11-3.63-2.79-5.71-7.02-5.71-11.59s2.08-8.79,5.71-11.59c.23-.18.57-.14.75.1.18.23.14.57-.1.75-3.36,2.59-5.29,6.5-5.29,10.74s1.93,8.15,5.29,10.74c.23.18.28.52.1.75-.11.14-.26.21-.43.21Z"
        />
      </g>
    </svg>
  );
}
